import { nvFetch } from '../helpers/nvFetch';
import { ApiSms, ApiSmsSend, SmsSend } from '../types/Sms';

export interface FetchSmsMessagesParams {
  page?: number;
  createdAfter?: string;
}

export const getSmsMessages = async (
  customerId: string,
  overrideParams: FetchSmsMessagesParams = {},
) => {
  const params = { page: 1, pageSize: 200, ...overrideParams };

  const fetchRes = await nvFetch(`/customers/${customerId}/sms`, {
    params,
  });
  const res: ApiSms[] = (await fetchRes.json()).items || [];

  return res;
};

export const sendSmsMessage = async (customerId: string, sms: SmsSend) => {
  const requestBody: ApiSmsSend = { type: 'smsmessage', ...sms };
  const fetchRes = await nvFetch(`/customers/${customerId}/sms`, {
    method: 'POST',
    body: JSON.stringify(requestBody),
  });
  const res = await fetchRes.json();

  return res as ApiSms;
};

export const combineSmsMessagesIntoThreads = (smsMessages: ApiSms[]) => {
  const threadsByNumber: Record<
    string,
    { number: string; messages: ApiSms[] }
  > = {};
  const numberOrdering: string[] = [];

  const sortedMessages = [...smsMessages].sort((a, b) => {
    const keyA = new Date(a.created);
    const keyB = new Date(b.created);
    // Compare the 2 dates
    if (keyA < keyB) return 1;
    if (keyA > keyB) return -1;
    return 0;
  });

  sortedMessages.forEach((m) => {
    const number = m.direction === 'IN' ? m.from : m.to;
    if (!threadsByNumber[number]) {
      threadsByNumber[number] = {
        number,
        messages: [],
      };
      numberOrdering.push(number);
    }
    threadsByNumber[number].messages.push(m);
  });
  return { threadsByNumber, numberOrdering };
};
